module.exports = __webpack_public_path__ + "st.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/st.svg
// module id = 820
// module chunks = 0